/* eslint-disable react-hooks/exhaustive-deps */
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {connect} from 'react-redux';
import {toast} from 'react-toastify';
import {Modal} from '../../../components';
import * as Actions from '../../../store/actions';
import {shortenLargeNumbers} from '../../../helpers/shortenLargeNumbers';
import {VerificationOption} from './utils';

function Address({
  widgets: {widgetScreen, widgetPages, widgetPricing},
  auth: {userDetails},
  setWidgetCurrentPricing,
  setWidgetScreen,
  setWidgetPages,
  ...otherProps
}) {
  const {open, setOpen} = otherProps;
  const [update, setUpdate] = useState(true);
  const [pricing, setPricing] = useState({
    services: {},
  });

  const [config, setConfig] = useState({
    verification: false,
    utilityBill: false,
    liveLocation: false,
  });

  const displayPrice = price =>
    shortenLargeNumbers(
      price || 0,
      userDetails?.company?.currency || 'NGN',
      {},
    );

  useEffect(() => {
    const isActive =
      widgetPages &&
      widgetPages?.find(
        data =>
          data?.page === 'address' && data[`${data?.page}-${data?.pageId}`],
      );
    if (isActive) {
      for (const key in config) {
        if (typeof config[key] === 'boolean') {
          setPricing(() => {
            const price =
              widgetPricing && widgetPricing?.address?.services[key];
            if (config[key] === true) {
              return {
                services: {
                  ...{
                    [key]: price / 100,
                  },
                },
              };
            }
          });
        }
      }

      setWidgetCurrentPricing({
        address: pricing,
      });
    } else {
      setWidgetCurrentPricing({
        address: {},
      });
    }
    return () => setWidgetCurrentPricing({address: {}});
  }, [widgetScreen, update, widgetPages, setWidgetCurrentPricing, config]);

  const foundWidget = useMemo(
    () =>
      widgetPages &&
      widgetPages?.find(
        data =>
          data?.pageId === widgetScreen?.pageId && data?.page === 'address',
      ),
    [widgetPages, widgetScreen],
  );

  const ALL_PAGES = JSON.parse(localStorage.getItem('pages'));
  const updateConfig = newConfig => {
    const newPages = ALL_PAGES.map(page => {
      if (page?.page === foundWidget?.page) {
        return {
          ...page,
          config: newConfig,
        };
      }
      return page;
    });

    localStorage.setItem('pages', JSON.stringify(newPages));
  };

  useEffect(() => {
    if (foundWidget) {
      if (Object.values(foundWidget?.config || {})?.length === 0) {
        setConfig({...config});
        setUpdate(false);
        setWidgetPages({
          ...foundWidget,
          config: {...config},
        });
        updateConfig({...config});
      } else {
        setConfig({...config, ...foundWidget?.config});
        setWidgetPages({
          ...foundWidget,
          config: {...config, ...foundWidget?.config},
        });
        updateConfig({...config, ...foundWidget?.config});
      }
    }
  }, [widgetScreen, update]);
  const handleUpdateConfig = useCallback(
    (value, key) => {
      const newData = widgetPages?.find(
        data => data?.pageId === widgetScreen?.pageId,
      );
      if (!newData) {
        return toast.error(
          'Ops! Please toggle ON before configuring this widget',
        );
      } else {
        const newConfig = {
          ...(key === 'utilityBill' &&
            !config.liveLocation && {
              utilityBill: value,
              verification: value,
            }),
          ...(key === 'liveLocation' && {
            liveLocation: value,
            verification: value,
            utilityBill: value,
          }),
          ...(key === 'verification' &&
            !config.utilityBill && {verification: value}),
        };
        if (key === 'verification' && config.liveLocation) {
          toast.error(
            'Cannot disable Geolocation, Proof of Address and Utility Bill require Geolocation.',
          );
        } else if (key === 'verification' && config.utilityBill) {
          toast.error('Utility Bill cannot be enabled without Geolocation.');
        }

        setConfig({...widgetScreen?.config, ...newConfig});
        setWidgetScreen({
          ...widgetScreen,
          config: {...widgetScreen.config, ...newConfig},
        });

        setWidgetPages({
          ...newData,
          config: {...newData?.config, ...newConfig},
        });
      }
    },
    [widgetPages],
  );

  return (
    <Modal
      show={open}
      onClose={setOpen}
      setOpen={setOpen}
      extraModalClasses="max-w-[369px] overflow-y-auto h-fit max-h-[95%] sm:max-h-full rounded-b-none sm:rounded-b-lg  absolute   bottom-0 sm:relative lookup-modal"
      modalPosition="justify-center sm:justify-end"
      modalTitle="Configuration"
      modalTitleBadge="NEW"
    >
      <div className="px-6 my-6 flex flex-col gap-3 ">
        <p className="text-left text-body text-[12px]  mb-2 leading-[16px]">
          Set Up Comprehensive Address Verification: Confirm user presence,
          validate utility bills, and capture proof of address.
        </p>

        <VerificationOption
          title="Verify Geo-Location"
          description="Verify that the user’s location is within 50m radius of the provided address"
          price={displayPrice(
            widgetPricing &&
              widgetPricing?.address?.services?.verification / 100,
          )}
          isChecked={config.verification}
          onToggle={value => {
            handleUpdateConfig(value, 'verification');
          }}
        />

        <VerificationOption
          title="Utility Bill"
          description="Add utility bill to verify your user’s Residential Address"
          // price="₦20.00"
          isChecked={config.utilityBill}
          onToggle={value => handleUpdateConfig(value, 'utilityBill')}
        />

        <VerificationOption
          title="Proof of Address"
          description="Let your users capture images of their current location to verify their address"
          // price="₦20.00"
          isChecked={config.liveLocation}
          onToggle={value => handleUpdateConfig(value, 'liveLocation')}
        />

        {/*<div className="flex gap-2 justify-center items-center mt-4 bg-statusBg-404 p-3 rounded-lg">*/}
        {/*  <img src={infoRedSm} alt="Info" width={20} />*/}
        {/*  <p className="text-xs text-black text-left">*/}
        {/*    Please note that Utility bill & Live location capture will be*/}
        {/*    reviewed*/}
        {/*  </p>*/}
        {/*</div>*/}
      </div>
    </Modal>
  );
}

export default connect(state => state, Actions)(Address);
